import { render } from "./quiz-v1-pagination.vue?vue&type=template&id=cbba124c&scoped=true"
import script from "./quiz-v1-pagination.vue?vue&type=script&lang=js"
export * from "./quiz-v1-pagination.vue?vue&type=script&lang=js"

import "./quiz-v1-pagination.vue?vue&type=style&index=0&id=cbba124c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbba124c"]])

export default __exports__